export default {
  borderRadius: '10px',
  border: '1px solid #c6c5c5',
  background: '#fff',
  padding: '1rem',
};
